export class NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto {
  driversLicensePhotoFileName?: string = undefined
  driversLicensePhotoFile?: File = undefined
}
